<template>
    <div>
        <sau-service-status :service="service"></sau-service-status>
        <dedicated-server-object-storage :id="service.id" />
        <sau-bandwidth-graph  v-if="showBandwidth && checked" class="pt-12" :service="service"></sau-bandwidth-graph>

        <div v-if="publicIpmiEnabled">
            <b-alert show variant="primary" class="mt-5">
                <div class="row">
                    <div class="col">
                        Public IPMI access is currently enabled. <span v-if="publicIpmiEndTime != 'Never'">It will be disabled automatically {{ publicIpmiEndTime }}.</span> <br>Disabling public access can increase the security of your device.
                    </div>
                    <div class="col-auto text-right">
                        <b-button variant="primary" class="text-white" :disabled="loading" @click="disablePublicIpmi">
                            Disable public IPMI <i v-if="loading" class="far fa-spinner-third fa-spin"></i>
                        </b-button>
                    </div>
                </div>
            </b-alert>
        </div>
    </div>
</template>

<script>
import PowerCheck from './_PowerCheck';
import StatusCheck from '@js/components/service/common/_Status';
import DedicatedServerObjectStorage from '@js/components/service/dedi/DedicatedServerObjectStorage';

export default {
    props: ['service'],
    components: {
        'sau-dedi-power-check': PowerCheck,
        'sau-service-status': StatusCheck,
        DedicatedServerObjectStorage,
    },

    data() {
        return {
            loading: false,
            capabilities: {
                publicIpmi: [],
            },
        }
    },

    computed: {
        publicIpmiEnabled() {
            if (this.capabilities.publicIpmi) {
                return _.get(this.capabilities, 'publicIpmi.enabled', false);
            }
            return false;
        },

        publicIpmiEndTime() {
            if (this.capabilities.publicIpmi) {
                const minutesUntilDisable = _.get(this.capabilities, 'publicIpmi.enabledMinutes', null);
                if(minutesUntilDisable === -1) {
                    return 'Never';
                } else if(minutesUntilDisable > 0) {
                    return moment().add(minutesUntilDisable, 'minutes').fromNow();
                }
            }
            return '';
        }
    },

    created() {
        this.fetchPublicIpmi();
    },

    methods: {
        fetchPublicIpmi() {
            this.getRequest(`/api/v2/services/${this.getServiceId()}/public-ipmi`)
                .then((response) => {
                    this.capabilities.publicIpmi = response.data;
                }).catch((error) => {
                    console.log(error);
                })
        },
        disablePublicIpmi() {
            this.loading = true;
            const url = `/api/v2/services/${this.currentService.id}/public-ipmi`;
            axios.post(url, { enabled: false, period: 0 })
                .then((response) => {
                    this.fetchPublicIpmi();
                    this.$swal({
                        type:'success',
                        title: 'Public IPMI access disabled succesfully',
                        showConfirmButton: false,
                        timer: 2500
                    });
                })
                .catch((error) => {
                    this.$swal({
                        type:'error',
                        title: 'Failed to disable public IPMI access. Please contact support if this problem persists.',
                        showConfirmButton: false,
                        timer: 2500
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>
